import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../../theme';
import { RichTextContent } from '../../RichTextContent';

export const StyledRichTextContent = styled(RichTextContent)`
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing(0, 0)};
    `}

    p {
        ${({ theme }: { theme: Theme }) => theme.typography.text_14};
        ${({ theme }: { theme: Theme }) => `
            margin: ${theme.tggSpacing(0, 0)};
	    `}
    }

    ul {
        ${({ theme }: { theme: Theme }) => `
            margin: ${theme.tggSpacing([rem(-0.5), 0, 0], [-1.25, 0, 0])};
	    `}

        li {
            ${({ theme }: { theme: Theme }) => theme.typography.text_14};
            ${({ theme }: { theme: Theme }) => `
                padding-left: ${theme.tggSpacing(0, 0)};

                &:last-child {
                    margin-bottom: ${theme.tggSpacing(0, 0)};
                }
	        `}
        }
    }
`;
